// Dates on the invoices (owner, 26 Sep 2026).
//
// - A date typed as text in the sheet is day/month/year in the UAE. `new Date('05/09/2026')`
//   reads it month-first (9 May) and `new Date('25/09/2026')` is Invalid, so text dates are
//   parsed explicitly here.
// - "Today" is the day in Dubai: `new Date().toISOString()` is the UTC day, so an invoice made
//   between 00:00 and 03:59 Dubai time was dated the day before.

const pad = (n) => String(n).padStart(2, '0');

const validDay = (y, m, d) => {
    const t = new Date(Date.UTC(y, m - 1, d));
    return t.getUTCFullYear() === y && t.getUTCMonth() === m - 1 && t.getUTCDate() === d;
};

/**
 * Sheet value -> 'dd/mm/yyyy'. Excel serial numbers, 'd/m/yyyy' (also with '-' or '.'),
 * and ISO 'yyyy-mm-dd[...]' are understood; anything else is returned as typed.
 */
export function formatInvoiceDate(value) {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value === 'number') {
        const t = new Date(Math.round((value - 25569) * 86400 * 1000));
        return `${pad(t.getUTCDate())}/${pad(t.getUTCMonth() + 1)}/${t.getUTCFullYear()}`;
    }
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? '' : value.toLocaleDateString('en-GB', { timeZone: 'Asia/Dubai' });
    }
    const text = String(value).trim();
    let m = /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})\b/.exec(text);
    if (m) {
        const [d, mo, y] = [Number(m[1]), Number(m[2]), Number(m[3])];
        return validDay(y, mo, d) ? `${pad(d)}/${pad(mo)}/${y}` : text;
    }
    m = /^(\d{4})-(\d{1,2})-(\d{1,2})\b/.exec(text);
    if (m) {
        const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
        return validDay(y, mo, d) ? `${pad(d)}/${pad(mo)}/${y}` : text;
    }
    return text;
}

/** Today in Dubai as 'yyyy-mm-dd' (the invoice date field's format). */
export function dubaiToday(now = new Date()) {
    // en-CA formats as yyyy-mm-dd
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
